/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const ArrowDownIcon = forwardRef(function ArrowDownIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-sanity-icon="arrow-down"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path d="M12.5 19.5V5" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" />
      <path
        d="M18 14L12.5 19.5L7 14"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
    </svg>
  )
})
ArrowDownIcon.displayName = 'ForwardRef(ArrowDownIcon)'
